import * as React from 'react';
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import { Utils, NumberFormatter, domainVal, DateFormatter, i18n } from 'arm-common';
import ApplicationData from '../../app/aApplicationData'

class Bisogno extends React.PureComponent {
    constructor(props) {
        super(props);
        this.componentName = "[Bisogno.jsx] ";
    }




    render() {
        let bisogno = this.props.bisogno;
        let indexBisogno = this.props.indexBisogno + 1;
        return (
            <div >
                <dl className="row">
                    <dt className="col-12">
                        {indexBisogno}) {i18n('ARM_CORE_PRODUCT.BISOGNO.BISOGNO', 'Bisogno')}: {bisogno.codiceBisogno} -
                        {ApplicationData.domainVal('AI_BISOGNO', bisogno.codiceBisogno, bisogno.codiceBisogno).desDom}
                        ({i18n('ARM_CORE_PRODUCT.BISOGNO.GRUPPI_PRODOTTO', 'Micro-categorie')}: {bisogno.gruppiProdottoBase.length})
                    </dt>
                </dl>



                {bisogno.gruppiProdottoBase.map((gruppoProdotto, indexGruppo) =>
                    <span
                        key={'G' + indexGruppo}>
                        <dd className="col-sm-4 col-12">{indexBisogno}.{indexGruppo + 1}) {i18n('ARM_CORE_PRODUCT.BISOGNO.MICRO_CATEGORIA', 'Micro-Categoria')}: {gruppoProdotto.nomeGruppo}</dd>
                        <br />
                        {gruppoProdotto.prodottiBase.map((prodotto, indexProdotto) =>
                            <span
                                key={'P' + indexProdotto}>
                                <dd className="ml-4 col-12">{indexBisogno}.{indexGruppo + 1}.{indexProdotto + 1}) {i18n('ARM_CORE_PRODUCT.BISOGNO.PRODOTTO', 'Prodotto')}: {prodotto.nomeProdotto}</dd>



                                <br />
                            </span>
                        )
                        }
                    </span>
                )
                }
                <br /><br />
            </div>
        );
    }
};



export default connect(null, null)(Bisogno);